
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["cog-icon cog-i-clock",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","focusable":"false","class":"cog-icon cog-i-clock"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('circle',{staticClass:"cog-i-clock__outline",attrs:{"cx":"9","cy":"9","r":"6.15","stroke-miterlimit":"10"}}),_c('path',{staticClass:"cog-i-clock__hands",attrs:{"d":"M9 5.06V9l2 2"}})])])
          )
        }
      }
    